import request from '@/utils/request'

//首页轮播图 
export function gettoppiclist(lang, params) {
    return request({
        url: `/${lang}/wms/dqgx/gettoppiclist/${params}`,
        method: 'get'
    })
}